import React from "react";
import { View, Platform, StyleSheet } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { Box } from "../layout/box";
import { Text } from "../text/text";
import { Button, useTheme, TouchableRipple } from "react-native-paper";
import { ThemeType } from "../../theme/theme";
import { PaymentSourceType } from "../../enums";
import { testProps } from "../../utils/testProps";

const { CREDIT_CARD } = PaymentSourceType;
const isIos = Platform.OS === "ios";

interface IProps {
  type: PaymentSourceType;
  onPress: (s: any) => any;
  disabled: boolean;
  isCertified: boolean;
}
export const AddPaymentMethodCard = ({ type, onPress, isCertified, disabled = false }: IProps) => {
  const { iconSize, colors } = useTheme() as ThemeType;
  const styles = getStyles();
  const text =
    type === CREDIT_CARD
      ? "homeStack.addCreditCard"
      : isCertified
      ? "homeStack.addCertifiedBank"
      : "homeStack.addBankAccount";

  return (
    <View style={styles.buttonContainer}>
      <TouchableRipple onPress={onPress} rippleColor="rgba(0, 0, 0, .32)" disabled={disabled}>
        <View style={styles.view} accessible={true}>
          <Button
            onPress={onPress}
            icon="plus-circle-outline"
            color={colors.darkGrey}
            {...testProps(text)}>
            <Text tx={text} />
          </Button>
        </View>
      </TouchableRipple>
    </View>
  );
};

const getStyles = () => {
  return StyleSheet.create({
    buttonContainer: {
      ...Platform.select({
        default: {
          width: 300,
          marginLeft: "auto",
          marginRight: "auto",
        },
      }),
    },
    view: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-around",
      alignItems: "center",
      borderWidth: 2,
      borderRadius: 20,
    },
  });
};
